<form *ngIf="application.body.cipQuestions.length > 0" #form="ngForm" (ngSubmit)="form.form.valid">
  <div class="row mt-3">
    <div *ngFor="let question of application.body.cipQuestions" class="col-12">
      <div *ngIf="!question.submitted" class="form-group">
        <label>{{question.question}}</label>
        <select class="form-control custom-select" name="answerId-{{question.id}}" [(ngModel)]="question.answerId" #answerId="ngModel" [ngClass]="inputFieldCss(answerId, form)" required>
          <option [ngValue]="null">{{ "onboarding.additional-questions.select" | translate: {Default:"Selecciona..."} }}</option>
          <option *ngFor="let answer of question.questionAnswers | keyvalue: asIsOrder" [ngValue]="answer.key">{{answer.value}}</option>
        </select>
        <app-field-error-display [control]="answerId" [form]="form"></app-field-error-display>
      </div>
    </div>
    <div class="col-12">
      <button class="btn btn-primary float-right" type="button" [disabled]="!form.form.valid" (click)="openModal(questionsConfirmation)">{{ "onboarding.additional-questions.continue" | translate: {Default:"Continuar"} }}</button>
    </div>
  </div>
</form>

<div *ngIf="application.body.cipQuestions.length == 0" class="row">
  <div class="col-12">
    <button class="btn btn-secondary float-left" type="button" (click)="onBack()">{{ "onboarding.additional-questions.back" | translate: {Default:"Regresar"} }}</button>
  </div>
</div>

<ng-template #questionsConfirmation let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ "onboarding.additional-questions.answersConfirm" | translate: {Default:"Confirma las respuestas"} }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body justify-content-center text-center">
    <div *ngFor="let ind = index;let question of application.body.cipQuestions">
      <div *ngFor="let answer of question.questionAnswers | keyvalue: asIsOrder">
        <p *ngIf="question.answerId == answer.key && !question.submitted"><b>{{ "onboarding.additional-questions.answer" | translate: {Default:"Respuesta"} }} {{ind + 1}}:</b> {{answer.value}}</p>
      </div>
    </div>
    <div class="modal-footer text-center">
      <div class="btn-group">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('Cross click')">{{ "onboarding.additional-questions.correct" | translate: {Default:"Corregir"} }}</button>
        <button type="button" class="btn btn-outline-primary" (click)="onSubmitKyc();modal.dismiss()">{{ "onboarding.additional-questions.confirm" | translate: {Default:"Confirmar"} }}</button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #blackListedModal let-modal>

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title2">{{ "onboarding.personal-data.registeredData" | translate: {Default:"Confirma los datos ingresados"} }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body justify-content-center text-center">
    <p>{{ "onboarding.personal-data.blackListedInfo" | translate: {Default:"Con la información actual que nos proporcionaste no será posible otorgarte una cuenta, por favor revisa que tus datos sean los correctos."} }}</p>
  </div>

  <div class="modal-footer text-center">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('Cross click');onBlackListedBack()">{{ "onboarding.personal-data.correct" | translate: {Default:"Corregir"} }}</button>
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cross click');onSubmit()">{{ "onboarding.personal-data.confirm" | translate: {Default:"Confirmar"} }}</button>
    </div>
  </div>
</ng-template>